import React, { memo } from 'react';

import Dialog from '@mui/material/Dialog';
import { Box, DialogContent, CircularProgress } from '@mui/material';

import Style from './ProgressLoadingModal.module.less';
import PropTypes from 'prop-types';

const ProgressLoadingModal = ({ progress }) => {
  if (!progress || !progress.shown) {
    return null;
  }

  return (
    <Dialog open={true} fullWidth={true} className={Style.Root} maxWidth={'sm'}>
      <DialogContent className={Style.Content}>
        <Box
          sx={{
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress variant={'indeterminate'} color={'primary'} size={72} />

          <div className={Style.Message}>{progress.message}</div>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ProgressLoadingModal.propTypes = {
  progress: PropTypes.shape({
    shown: PropTypes.bool,
    message: PropTypes.any,
  }),
};

export default memo(ProgressLoadingModal);
